import { AssignmentIcon, IconSize, IconWrapper, Link, TextInput } from '@dreryk/react-components';

import { magistralDrugTranslationKeys } from '../../../../../translations';
import { MagistralDrugCreateFormController } from '../MagistralDrugCreateForm.types';

type DrugNameTextInputProps = Pick<MagistralDrugCreateFormController, 'register'> & {
   readonly onInsertClick: VoidFunction;
};

export const DrugNameTextInput = (props: DrugNameTextInputProps): JSX.Element => {
   return (
      <TextInput
         label={magistralDrugTranslationKeys.drugName}
         labelSuffixElement={
            <Link
               testId={'insertFromTemplate'}
               label={magistralDrugTranslationKeys.insertFromTemplate}
               icon={
                  <IconWrapper testId={'insertFromTemplate'} size={IconSize.SMALL}>
                     <AssignmentIcon />
                  </IconWrapper>
               }
               onClick={props.onInsertClick}
            />
         }
         testId={'drugName'}
         controller={props.register('drugName', { maxLength: 200 })}
      />
   );
};
